const keyInformation1 = {
  properties: "enjoy",
  device: "Close Range",
  name: "Sword",
  Image:
    "https://github.com/al1103/-/blob/main/Ebony%20blade_clipdrop-background-removal.png?raw=true",
};
const keyInformation2 = {
  properties: "enjoy",
  device: "Devices",
  name: "Gun",
  Image:
    "https://github.com/al1103/-/blob/main/Black%20Ops%20Rifle%20IPhone%20Wallpaper%20HD%20-%20IPhone%20Wallpapers_clipdrop-background-removal.png?raw=true",
};
const keyInformation3 = {
  properties: "enjoy",
  device: "Range",
  name: "Archery",
  Image:
    "https://github.com/al1103/-/blob/main/download_clipdrop-background-removal.png?raw=true",
};
const keyInformation4 = {
  properties: "enjoy",
  device: "Multi use",
  name: "Battle axe",
  Image:
    "https://github.com/al1103/-/blob/main/Tomahawk%20_%20M48%20Destroyer%20Tactical,%20Eloi%20Farriol_clipdrop-background-removal.png?raw=true",
};
const keyInformation5 = {
  properties: "enjoy",
  device: "Bart",
  name: "Bullet",
  Image:
    "https://github.com/al1103/-/blob/main/10%20Most%20Common%20Reloading%20Mistakes%20-%20Shooting%20Times_clipdrop-background-removal.png?raw=true",
};
const keyInformation6 = {
  properties: "enjoy",
  device: "Range",
  name: "Spear",
  Image:
    "https://github.com/al1103/-/blob/main/download_clipdrop-background-removal.png?raw=true",
};
export {
  keyInformation1,
  keyInformation2,
  keyInformation3,
  keyInformation4,
  keyInformation5,
  keyInformation6,
};
